<template>
  <section class="i-sessions">

    <h1>Sessions</h1>
    <div class="my-3">
      <v-layout row wrap justify-space-between>
        <v-flex xs4 fluid align-center justyfy-center>
          <v-dialog persistent v-model="modalWindow" max-width="900px">
            <v-btn color="primary" dark slot="activator" v-if="isWriteAvailable" class="mb-2">Add Session</v-btn>
            <v-card v-if="showEditForm"  class="pa-2">
              <v-card-title>
                <span class="headline">{{ formTitle }} </span>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-flex xs12>
                    <v-layout row justify-end>
                      <v-flex xs12 sm6 v-if="!isMultiLocation">
                        <content-field
                          label="Location Id"
                          disabled
                          :error="$v.dataForForm.sessionForm.locationId"
                          v-model="dataForForm.selectedLocation.name"/>
                      </v-flex>
                      <v-flex sm3 v-if="!isMultiLocation">
                        <v-dialog persistent v-model="locationsModalWindow" max-width="500px">
                          <v-btn color="primary" dark slot="activator">Select Location</v-btn>
                          <v-list>
                            <v-list-tile
                              avatar
                              v-for="item in locationsList"
                              :key="item.id"
                              @click="addIdLocation(item)">
                                <!--<v-list-tile-avatar>-->
                                  <!--<img :src="item.icon">-->
                                <!--</v-list-tile-avatar>-->
                                <v-list-tile-content>
                                  <v-list-tile-title v-text="item.name"></v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-icon color="success">add_circle</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-dialog>
                      </v-flex>

                      <v-flex sm3>
                        <v-checkbox
                          label="Multi location"
                          v-model="isMultiLocation"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>

                    <div>
                      <v-flex xs11 sm6>
                        <v-select
                          v-if="agendaSettings"
                          label="Select date"
                          :items="makeDateArr()"
                          required
                          :error="$v.dataForForm.selectedDate.$error"
                          v-model="dataForForm.selectedDate"
                          max-height="400"
                        />
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs5>
                          <v-switch v-model="dataForForm.sessionForm.onDemand" label="On demand"/>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs11 sm4>
                          <v-dialog
                            ref="dialogStartTime"
                            persistent
                            v-model="isStartTime"
                            lazy
                            full-width
                            width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              label="Select start time"
                              :error="$v.dataForForm.startTime.$error"
                              v-model="dataForForm.startTime"
                              prepend-icon="access_time"
                              readonly
                            />
                            <v-time-picker
                              v-model="dataForForm.startTime"
                              :max="getAvailableMaxStartTime"
                              actions
                            >
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="toggleModal('isStartTime')">Cancel</v-btn>
                              <v-btn flat color="primary" @click="$refs.dialogStartTime.save(dataForForm.startTime)">OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex sm1 style='cursor: pointer; align-items: center; display: flex' v-if="dataForForm.startTime" @click="resetTime('startTime')">
                          <v-icon>delete</v-icon>
                        </v-flex>

                        <v-flex xs11 sm4>
                          <v-dialog
                            v-if="dataForForm.startTime && !dataForForm.sessionForm.onDemand"
                            ref="dialogEndTime"
                            persistent
                            v-model="isEndTime"
                            lazy
                            full-width
                            width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              label="Select end time"
                              :error="$v.dataForForm.endTime.$error"
                              v-model="dataForForm.endTime"
                              prepend-icon="access_time"
                              readonly
                            />
                            <v-time-picker
                              v-model="dataForForm.endTime"
                              :min="getAvailableMinEndTime"
                              actions
                            >
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="toggleModal('isEndTime')">Cancel</v-btn>
                              <v-btn flat color="primary" @click="$refs.dialogEndTime.save(dataForForm.endTime)">OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex sm1 style='cursor: pointer; align-items: center; display: flex' v-if="dataForForm.endTime" @click="resetTime('endTime')">
                          <v-icon>delete</v-icon>
                        </v-flex>
                      </v-layout>
                    </div>

                    <div v-if="currentTypeSession === 'Placeholder Image'">
                      <v-flex xs12>
                        <content-field
                          label="Link"
                          v-model="dataForForm.sessionForm.metadata.link"
                        />
                      </v-flex>
                    </div>

                    <!--RADIO BUTTONS-->
                    <pre>{{ currentTypeSession }}</pre>
                    <v-flex sm12>
                      <v-radio-group row v-model="currentTypeSession">
                        <v-radio
                          v-for="(item, index) in typesSessions"
                          :key="`type-${index}`"
                          :label="item"
                          :value="item"/>
                      </v-radio-group>
                    </v-flex>

                    <!--PLACEHOLDER IMAGE FORM-->

                    <div v-if="currentTypeSession === 'Placeholder Image'">
                      <v-btn color="success" @click="toggleModal('modalPlaceholderImageGallery')">
                        Choose Placeholder Image
                      </v-btn>
                      <v-flex v-if="dataForForm.sessionForm.placeholderImage">
                        <v-card flat tile>
                          <v-card-media
                            :src="dataForForm.sessionForm.placeholderImage"
                            height="400px"
                          >
                          </v-card-media>
                        </v-card>
                      </v-flex>
                      <v-flex>
                        <v-card flat>
                          <e-color-picker
                            label="Event background color"
                            @colorChange="onEventColorChange"
                            v-model="dataForForm.sessionForm.sessionConfiguration.eventColor"/>
                        </v-card>
                      </v-flex>
                      <v-dialog v-model="modalPlaceholderImageGallery">
                        <galleries-list :modalView="true" @pickedImage="setPlaceholderImage"/>
                      </v-dialog>
                    </div>

                    <!--FEATURED FORM-->

                    <div v-if="currentTypeSession === 'Featured'">
                      <v-layout row justify-space-between column>
                        <v-flex xs6>
                          <content-field
                            label="Title"
                            :error="$v.dataForForm.sessionForm.metadata.featuredOptions.title"
                            v-model="dataForForm.sessionForm.metadata.featuredOptions.title"/>
                        </v-flex>
                        <v-flex xs12 class="pa-3 color-checkbox-block">
                          <v-layout row align-center>
                            <v-flex xs5>
                              <v-checkbox
                                class="color-checkbox"
                                label="Background Color"
                                v-model="isColorBoxChecked"
                              />
                            </v-flex>
                            <v-flex xs5>
                              <e-color-picker
                                v-if="isColorBoxChecked"
                                label="Background Color"
                                v-model="dataForForm.sessionForm.metadata.featuredOptions.backgroundColor"
                                @colorChange="onColorChange"
                              />
                            </v-flex>
                          </v-layout>
                          <v-layout row align-center>
                            <v-flex xs5>
                              <v-checkbox
                                class="color-checkbox"
                                label="Hover Background Color"
                                v-model="isHoverColorBoxChecked"
                              />
                            </v-flex>
                            <v-flex>
                              <e-color-picker
                                v-if="isHoverColorBoxChecked"
                                label="Hover Background Color"
                                v-model="dataForForm.sessionForm.metadata.featuredOptions.hoverBackgroundColor"
                                @colorChange="onHoverColorChange"
                              />
                            </v-flex>
                          </v-layout>
                          <v-flex class="mx-2 height-16">
                          </v-flex>
                        </v-flex>
                      </v-layout>

                      <v-layout row justify-space-around align-content-end>
                        <v-card width="320">
                          <div class="grey lighten-2">
                            <v-card-media height="130" :src="dataForForm.sessionForm.metadata.featuredOptions.logo"/>
                          </div>

                          <v-card-title><h3>Item for featured session</h3></v-card-title>
                          <v-card-actions>
                            <v-btn flat color="success" @click="toggleModal('modalLogoGallery')">Choose</v-btn>
                            <v-btn
                              flat color="error"
                              :disabled="!isLogoChosen"
                              @click="resetLogoImage">Reset
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <v-card width="320">
                          <div class="grey lighten-2">
                            <v-card-media height="130" :src="dataForForm.sessionForm.metadata.featuredOptions.image"/>
                          </div>
                          <v-card-title><h3>Image for featured session</h3></v-card-title>
                          <v-card-actions>
                            <v-btn flat color="success" @click="toggleModal('modalGallery')">Choose</v-btn>
                            <v-btn
                              flat color="error"
                              :disabled="!isImageChosen"
                              @click="resetImage">Reset
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                      </v-layout>

                      <div>
                        <v-dialog v-model="modalGallery">
                          <galleries-list :modalView="true" @pickedImage="setImage"/>
                        </v-dialog>
                      </div>

                      <div>
                        <v-dialog v-model="modalLogoGallery">
                          <galleries-list :modalView="true" @pickedImage="setLogoImage"/>
                        </v-dialog>
                      </div>

                    </div>

                    <!--Lunchtime FORM-->
                    <div v-if="currentTypeSession === 'Lunchtime'">
                      <v-card class="pa-2 mb-3 elevation-4">
                        <span class="headline">Session description:</span>
                        <v-flex xs12>
                          <content-field
                            label="Title"
                            maxlength="400"
                            :error="$v.dataForForm.sessionForm.title"
                            v-model="dataForForm.sessionForm.title"/>
                        </v-flex>

                        <v-flex xs12>
                          <content-field
                            label="Label"
                            maxlength="400"
                            :error="$v.dataForForm.sessionForm.eventLabel"
                            v-model="dataForForm.sessionForm.eventLabel"/>
                        </v-flex>
                      </v-card>
                      <v-card class="pa-2 mb-3 elevation-4">
                        <v-flex xs12>
                          <e-color-picker
                            label="Event background color"
                            @colorChange="onEventColorChange"
                            v-model="dataForForm.sessionForm.sessionConfiguration.eventColor"/>
                        </v-flex>
                      </v-card>
                    </div>

                    <!--REGULAR FORM-->

                    <div v-if="currentTypeSession === 'Regular'">
                      <v-card class="mb-3 elevation-4 pa-2">
                        <span class="headline">Speakers settings:</span>
                        <v-dialog persistent v-model="speakersModalWindow" max-width="500px">
                          <v-btn color="primary" dark slot="activator">Add speakers</v-btn>
                          <v-list>
                            <v-list-tile
                              avatar
                              v-for="item in publishedSpeakers"
                              :key="item.id"
                              @click="addSpeaker(item)"
                            >
                              <v-list-tile-action>
                                <v-icon color="success" v-if="checkSpeakersQuantity(item.id)">
                                  check_box_outline_blank
                                </v-icon>
                                <v-icon color="success" v-else>check_box</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title v-text="item.name"></v-list-tile-title>
                              </v-list-tile-content>
                              <v-list-tile-avatar>
                                <img :src="item.image">
                              </v-list-tile-avatar>
                            </v-list-tile>
                            <v-btn color="grey lighten-1" @click="toggleModal('speakersModalWindow')">Close</v-btn>
                          </v-list>
                        </v-dialog>
                        <v-layout row wrap justify-start v-if="dataForForm.sessionForm.speakersIds">
                          <drag
                            v-model="dataForForm.sessionForm.speakersIds"
                            :options="dragOptions"
                            class="drag-container"
                          >
                            <v-card
                              v-for="(el, index) in dataForForm.sessionForm.speakersIds" class="mx-2 mb-2 mt-3"
                              :key="`el-${index}`"
                              width="100"
                            >
                              <v-flex align-center justify-center>
                                <v-card-media height="60px" :src="speakerObj(el).image"></v-card-media>
                                <h3 class="pa-2">{{speakerObj(el).name}}</h3>
                              </v-flex>
                            </v-card>
                          </drag>
                        </v-layout>

                        <v-layout>
                          <v-flex xs9 class="pl-3"
                          >
                            <v-select
                              :items="publishedSpeakers"
                              v-model="dataForForm.sessionForm.metadata.moderatorId"
                              item-value="id"
                              item-text="name"
                              label="Select Moderator"
                            />
                          </v-flex>
                          <v-flex xs3 class="pl-3">
                            <v-btn color="blue darken-1" flat @click.stop="resetModerator">Reset moderator</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <v-card class="pa-2 mb-3 elevation-4">
                        <span class="headline">Session description:</span>
                        <v-flex xs12>
                          <content-field
                            label="Title"
                            maxlength="400"
                            :error="$v.dataForForm.sessionForm.title"
                            v-model="dataForForm.sessionForm.title"/>
                        </v-flex>

                        <v-flex xs12>
                          <content-field
                            label="Label"
                            maxlength="400"
                            :error="$v.dataForForm.sessionForm.eventLabel"
                            v-model="dataForForm.sessionForm.eventLabel"/>
                        </v-flex>

                        <v-flex xs12>
                          <v-card-title><h3>Full Description</h3></v-card-title>
                          <content-editor
                            :error="$v.dataForForm.sessionForm.fullDescription"
                            v-model="dataForForm.sessionForm.fullDescription"/>
                        </v-flex>

                        <v-flex xs12>
                          <v-card-title><h3>Short Description</h3></v-card-title>
                          <content-editor
                            :error="$v.dataForForm.sessionForm.shortDescription"
                            v-model="dataForForm.sessionForm.shortDescription"/>
                        </v-flex>
                      </v-card>

                      <v-card class="pa-2 elevation-4">
                        <span class="headline">Session configuration:</span>
                        <v-layout row>
                          <v-flex xs5>
                            <v-switch v-model="dataForForm.sessionForm.metadata.translator" label="Translation"/>
                          </v-flex>

                          <!--<v-flex>-->
                          <!--<v-checkbox label="Add Session Configuration" v-model="isSessionConfiguration"/>-->
                          <!--</v-flex>-->
                        </v-layout>
                        <content-field
                          label="Email address"
                          v-model="dataForForm.sessionForm.sessionConfiguration.emailAddress"/>
                        <v-layout row justify-space-between>
                          <v-flex xs3>
                            <v-select
                              label="Time font weight"
                              :items="arrayForWeight"
                              v-model="dataForForm.sessionForm.sessionConfiguration.timeFontWeight"/>
                          </v-flex>
                          <v-flex xs3>
                            <v-select
                              label="Title font weight"
                              :items="arrayForWeight"
                              v-model="dataForForm.sessionForm.sessionConfiguration.titleFontWeight"/>
                          </v-flex>
                          <v-flex xs3>
                            <e-color-picker
                              label="Title color"
                              @colorChange="onTitleColorChange"
                              v-model="dataForForm.sessionForm.sessionConfiguration.titleColor"/>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs12>
                            <e-color-picker
                              label="Event background color"
                              @colorChange="onEventColorChange"
                              v-model="dataForForm.sessionForm.sessionConfiguration.eventColor"/>
                          </v-flex>
                        </v-layout>

                        <v-card-title><h3>Ask question</h3></v-card-title>

                        <v-layout row justify-start>
                          <v-flex xs4 class="pa-3">
                            <v-checkbox v-model="isLimitedCharacters" label="Add characters limit"/>
                          </v-flex>
                          <v-flex xs3>
                            <content-field
                              v-if="isLimitedCharacters"
                              label="Number of characters"
                              type="number"
                              :error="$v.dataForForm.sessionForm.sessionConfiguration.askQuestion.charactersLimit"
                              v-model="dataForForm.sessionForm.sessionConfiguration.askQuestion.charactersLimit"/>
                          </v-flex>

                        </v-layout>
                        <content-field
                          label="Email Placeholder"
                          :error="$v.dataForForm.sessionForm.sessionConfiguration.askQuestion.inputPlaceholder"
                          v-model="dataForForm.sessionForm.sessionConfiguration.askQuestion.inputPlaceholder"/>
                        <content-field
                          label="Question Placeholder"
                          :error="$v.dataForForm.sessionForm.sessionConfiguration.askQuestion.text"
                          v-model="dataForForm.sessionForm.sessionConfiguration.askQuestion.text"
                        />
                      </v-card>
                    </div>

                    <div>
                      <v-card class="pa-2 elevation-4">
                        <span class="headline">Stream/Video configuration:</span>
                        <v-layout row>
                          <v-flex xs12>
                            <content-field
                              label="Stream/video url"
                              v-model="dataForForm.sessionForm.streamVideoUrl"/>
                          </v-flex>
                        </v-layout>

                        <v-layout row>
                          <v-flex xs12>
                            <v-select
                              label="Type"
                              :items="streamVideoTypesList"
                              v-model="dataForForm.sessionForm.streamVideoType"/>
                          </v-flex>
                        </v-layout>

                        <!-- start time section -->
                        <v-layout row wrap>
                          <v-flex xs11 sm4>
                            <v-dialog
                              ref="dialogStartTime"
                              persistent
                              v-model="isStreamStartTime"
                              lazy
                              full-width
                              width="290px"
                            >
                              <v-text-field
                                slot="activator"
                                label="Select start time"
                                v-model="dataForForm.streamStartTime"
                                prepend-icon="access_time"
                                readonly
                              />
                              <v-time-picker
                                v-model="dataForForm.streamStartTime"
                                :max="getAvailableMaxStreamStartTime"
                                actions
                              >
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toggleModal('isStreamStartTime')">Cancel</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialogStartTime.save(dataForForm.streamStartTime)">OK
                                </v-btn>
                              </v-time-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex sm1 style='cursor: pointer; align-items: center; display: flex' v-if="dataForForm.streamStartTime" @click="resetTime('streamStartTime')">
                            <v-icon>delete</v-icon>
                          </v-flex>

                          <v-flex xs11 sm4>
                            <v-dialog
                              ref="dialogEndTime"
                              persistent
                              v-model="isStreamEndTime"
                              lazy
                              full-width
                              width="290px"
                            >
                              <v-text-field
                                slot="activator"
                                label="Select end time"
                                v-model="dataForForm.streamEndTime"
                                prepend-icon="access_time"
                                readonly
                              />
                              <v-time-picker
                                v-model="dataForForm.streamEndTime"
                                :min="getAvailableMinStreamEndTime"
                                actions
                              >
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toggleModal('isStreamEndTime')">Cancel</v-btn>
                                <v-btn flat color="primary" @click="toggleModal('isStreamEndTime')">OK
                                </v-btn>
                              </v-time-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex sm1 style='cursor: pointer; align-items: center; display: flex' v-if="dataForForm.streamEndTime" @click="resetTime('streamEndTime')">
                            <v-icon>delete</v-icon>
                          </v-flex>
                        </v-layout>

                        <!-- end time section -->
                      </v-card>

                    </div>

                    <!-- <pre>{{ dataForForm }}</pre> -->

                  </v-flex>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.stop="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.stop="saveSession">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn color="primary" @click="reset">Reset</v-btn>
        </v-flex>

        <v-flex xs2>
          <v-select
            :items="locationsList"
            v-model="locationForFilter"
            label="Locations"
            item-value="id"
            item-text="name"
          />
        </v-flex>
        <v-flex xs2>
          <v-select
            :items="typesSessions"
            v-model="typeForFilter"
            label="Types"
          />
        </v-flex>

        <!--TODO: Filter by day-->

        <!--<v-flex xs2>-->
        <!--<v-select :items=""-->
        <!--v-model="dayForFilter"-->
        <!--label="Days"-->
        <!--item-text=""></v-select>-->
        <!--</v-flex>-->

        <v-flex xs3>
          <v-text-field
            append-icon="search"
            label="Search by Title"
            v-model="filterTitle"
          />
        </v-flex>
        <v-flex xs2>
          <v-text-field
            append-icon="search"
            label="Search by Description"
            v-model="filterDescription"
          />
        </v-flex>

      </v-layout>

      <v-data-table
        :headers="headers"
        :items="sessionsList"
        class="elevation-1 wrap"
        :pagination.sync="pagination"
        :total-items="totalItemsInTable"
        :loading="loading"
        item-key="id"
        :disable-initial-sort="true"
      >
        <template slot="items" slot-scope="props">
          <td class="py-4">{{pathOr('location not selected', ['item', 'location', 'name'], props)}}</td>
          <td class="py-4">
            {{
              pathOr('', ['item', 'metadata', 'featuredOptions', 'title'], props) ||
              pathOr('', ['item', 'title'], props) ||
              props.item.metadata.sessionType ||
              'No title'
            }}
            </td>
          <td class="py-4" v-html="pathOr('', ['item', 'shortDescription'], props)"></td>
          <td class="py-4">{{substring(props.item.startTime, 0, 10)}}</td>
          <td class="py-4">{{substring(props.item.startTime, 11, 16)}}</td>
          <td class="py-4">{{substring(props.item.endTime, 11, 16)}}</td>
          <td class="py-4">{{props.item.metadata.sessionType}}</td>
          <td class="py-4">{{props.item.status}}</td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="blue lighten-1"
                fab flat
                slot="activator"
                @click.stop="changeStatus(props.item)"
                :disabled="!isWriteAvailable"
              >
                <v-icon>flag</v-icon>
              </v-btn>
              <span>publish</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="lime"
                fab flat
                slot="activator"
                :disabled="!isWriteAvailable"
                @click.stop="editItem(props.item)"
              >
                <v-icon>create</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="error"
                fab flat
                slot="activator"
                :disabled="!isWriteAvailable"
                @click.stop="deleteSession(props.item.id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
        <template slot="pageText" slot-scope="{}">
          Page {{pagination.page}} of {{totalSessionsPages}}
        </template>
      </v-data-table>
    </div>
    <display-agenda-settings
      :id="sessionId"
      :is-modal-show="isShowWarningModal"
      @displayAgendaSettings="displayAgendaSettingsDone(sessionId)"
    />
  </section>
</template>

<script>
/**
 * TODO:
 * refactoir component:
 * 1) move form to separate component
 * 2) move modal for choosing speakers to separate component
 */

import { mapActions, mapGetters } from 'vuex'
import ContentField from '@/components/shared/ContentField/index.vue'
import GalleriesList from '@/components/pages/Gallery/GalleriesList'
import DisplayAgendaSettings from '@/components/shared/DisplayAgendaSettings/index.vue'
import ContentEditor from '@/components/shared/ContentEditor/index.vue'
import { required, email, numeric } from 'vuelidate/lib/validators'
import EColorPicker from '@/components/shared/EColorPicker'
import { equals, clone, pathOr, remove, map, prop, propEq, not, isNil, filter, compose, path, isEmpty } from 'ramda'
import debounce from 'lodash.debounce'
import { timeSettings } from '@/modules/settings/'
import mixins from '@/utils/mixins'

export default {
  name: 'Sessions',
  mixins: [mixins.isWriteAvailable],
  components: {
    DisplayAgendaSettings,
    EColorPicker,
    ContentEditor,
    GalleriesList,
    ContentField
  },
  data () {
    return {
      isLogoChosen: false,
      isImageChosen: false,
      publishedSpeakers: [],
      moderatorId: '',
      locationsModalWindow: false,
      speakersModalWindow: false,
      arrayForWeight: ['100', '200', '300', '400', '500', '600', '700', '800'],
      currentTypeSession: '',
      typesSessions: ['Regular', 'Featured', 'Placeholder Image', 'Lunchtime'],
      locationForFilter: '',
      typeForFilter: '',
      // dayForFilter: '',
      editedIndex: -1,
      showEditForm: true,
      modalWindow: false,
      modalGallery: false,
      modalLogoGallery: false,
      modalPlaceholderImageGallery: false,
      isMultiLocation: false,
      dataForForm: {
        sessionForm: {
          sessionConfiguration: {}
        }
      },
      defaultDataForForm: {
        sessionForm: {
          sessionConfiguration: {}
        }
      },
      isLimitedCharacters: false,
      isSessionConfiguration: true,
      isDate: false,
      isStartTime: false,
      isEndTime: false,
      isStreamStartTime: false,
      isStreamEndTime: false,
      streamVideoTypesList: ['Live', 'Prerecorded', 'Semi-live'],
      headers: [
        {text: 'Location', value: 'location', search: false, sortable: false, width: 100},
        {text: 'Title Session', value: 'title', search: true, sortable: true, width: 200},
        {text: 'Short description', value: 'shortDescription', search: true, sortable: true, width: 200},
        {text: 'Day', value: 'day', search: false, sortable: false, width: 50},
        {text: 'Start time', value: 'start-time', search: false, sortable: false, width: 50},
        {text: 'End time', value: 'end-time', search: false, sortable: false, width: 50},
        {text: 'Type of session', value: 'type', search: false, sortable: false, width: 100},
        {text: 'Status', value: 'status', search: false, sortable: false, width: 100},
        {text: 'Publish', search: false, sortable: false, align: 'center', width: 50},
        {text: 'Edit', search: false, sortable: false, align: 'center', width: 50},
        {text: 'Delete', search: false, sortable: false, align: 'center', width: 50}
      ],
      pagination: {
        rowsPerPage: 5
      },
      loading: true,
      filterTitle: '',
      filterDescription: '',
      dragOptions: {
        ghostClass: 'before-drag-drop'
      },
      isColorBoxChecked: false,
      isHoverColorBoxChecked: false,
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'agenda:write',
      isShowWarningModal: false
    }
  },
  validations () {
    const form = {
      dataForForm: {
        sessionForm: {},
        selectedDate: {required},
        startTime: {required},
        endTime: {},
      }
    }
    if (this.currentTypeSession === 'Regular') {
      form.dataForForm.sessionForm = {
        locationId: {required},
        title: {required},
        // fullDescription: {required},
        shortDescription: {required},
      }
      if (this.isSessionConfiguration) {
        form.dataForForm.sessionForm.sessionConfiguration = {
          askQuestion: {
            charactersLimit: {numeric}
          }
        }
      }
    }
    if (this.currentTypeSession === 'Lunchtime') {
      form.dataForForm.sessionForm = {
        title: {required}
      }
    }
    if (this.currentTypeSession === 'Placeholder Image') {
      form.dataForForm.sessionForm = {
        locationId: {required},
        placeholderImage: {required}
      }
    }
    if (this.currentTypeSession === 'Featured') {
      form.dataForForm.sessionForm = {
        locationId: {required}
      }
      form.dataForForm.sessionForm.metadata = {
        featuredOptions: {
          title: {required}
        }
      }
    }
    if (this.isMultiLocation) {
      delete form.dataForForm.sessionForm.locationId
    }
  return form
  },
  computed: {
    ...mapGetters([
      'getSettings',
      'locationsList',
      'sessionsList',
      'totalSessionsPages',
      'totalSessionsItems',
      'getPublishedSpeakers',
      'sessionsListState'
    ]),
    sessionId () {
      return path(['sessionForm', 'id'], this.dataForForm)
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Creation Of New Session' : 'Edit Session'
    },
    minDate () {
      if (this.agendaSettings) {
        return this.substring(this.agendaSettings.eventConfiguration.startDate, 0, 10)
      }
    },
    maxDate () {
      if (this.agendaSettings) {
        return this.substring(this.agendaSettings.eventConfiguration.endDate, 0, 10)
      }
    },
    totalItemsInTable () {
      return this.totalSessionsItems || (this.totalSessionsPages * this.pagination.rowsPerPage)
    },
    agendaSettings () {
      return path(['agendaSetting'], this.getSettings)
    },
    getAvailableMaxStartTime () {
      return this.dataForForm.endTime
    },
    getAvailableMinEndTime () {
      return this.dataForForm.startTime
    },
    getAvailableMaxStreamStartTime () {
      return this.dataForForm.streamEndTime
    },
    getAvailableMinStreamEndTime () {
      return this.dataForForm.streamStartTime
    }
  },
  watch: {
    getPublishedSpeakers (val) {
      this.publishedSpeakers = [...val]
    },
    pagination: {
      handler (val, oldVal) {
        if (!this.isPaginationChanged(val, oldVal)) return
        this.getSessions()
      },
      deep: true
    },
    filterTitle () {
      this.getSessions()
    },
    typeForFilter () {
      this.getSessions()
    },
    filterDescription () {
      this.getSessions()
    },
    'dataForForm.selectedLocation' (val) {
      this.dataForForm.sessionForm.locationId = val.id
    },
    isMultiLocation (val) {
      this.dataForForm.sessionForm.locationId = val
        ? null
        : this.dataForForm.selectedLocation.id
    },
    locationForFilter () {
      this.getSessions()
    },
    modalWindow (val) {
      if (val) {
        this.currentTypeSession = this.dataForForm.sessionForm.metadata.sessionType
      } else {
        this.resetForm()
      }
    },
    currentTypeSession (val) {
      this.dataForForm.sessionForm.metadata.sessionType = val
      if (val === 'Lunchtime') this.dataForForm.sessionForm.title = val
    },
    dataForForm: {
      handler (newVal) {
        if(!isEmpty(newVal)) {
          if (this.dataForForm.sessionForm.metadata.featuredOptions.backgroundColor.hex) {
            this.isColorBoxChecked = true
          }
          if (this.dataForForm.sessionForm.metadata.featuredOptions.hoverBackgroundColor.hex) {
            this.isHoverColorBoxChecked = true
          }
          if (path(['sessionForm', 'metadata', 'featuredOptions', 'image'], this.dataForForm)) {
            this.isImageChosen = true
          }else{
            this.isImageChosen = false
          }
          if (path(['sessionForm', 'metadata', 'featuredOptions', 'logo'], this.dataForForm)){
            this.isLogoChosen = true
          }else{
            this.isLogoChosen = false
          }
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'removeSession',
      'getLocationsList',
      'createSession',
      'getSessionsList',
      'editSession',
      'fetchSpeakersList',
      'changeStatusToPublished',
      'fetchGeneralSettings'
    ]),
    pathOr,
    resetModerator () {
      this.dataForForm.sessionForm.metadata.moderatorId = null
    },
    checkSpeakersQuantity (id) {
      return this.dataForForm.sessionForm.speakersIds.indexOf(id) < 0
    },
    getLimitationForData (key) {
      // key = startDate | endDate
      return pathOr(
        this.$moment.utc(new Date()).format(),
        ['eventConfiguration', key],
        this.agendaSettings
      )
    },
    changeStatus (session) {
      this.changeStatusToPublished(session)
      this.getSessions()
    },
    addIdLocation (item) {
      this.dataForForm.selectedLocation = {...item}
      this.toggleModal('locationsModalWindow')
    },
    addSpeaker (item) {
      let index = this.dataForForm.sessionForm.speakersIds.indexOf(item.id)
      if (index < 0) {
        this.dataForForm.sessionForm.speakersIds = [...this.dataForForm.sessionForm.speakersIds, item.id]
      } else {
        this.dataForForm.sessionForm.speakersIds = remove(index, 1, this.dataForForm.sessionForm.speakersIds)
      }
      this.publishedSpeakers = [...this.publishedSpeakers]
    },
    speakerObj (el) {
      let speaker = this.getPublishedSpeakers.find((item) => item.id === el)
      return speaker
    },
    setStartTime () {
      this.dataForForm.sessionForm.startTime = `${this.convertDateToCorrectFormat(this.dataForForm.selectedDate)}T${this.dataForForm.startTime}:00.000Z`
    },
    setEndTime () {
      if (this.dataForForm.endTime) this.dataForForm.sessionForm.endTime = `${this.convertDateToCorrectFormat(this.dataForForm.selectedDate)}T${this.dataForForm.endTime}:00.000Z`
    },
    setStreamStartTime () {
      this.dataForForm.sessionForm.streamStartTime = `${this.convertDateToCorrectFormat(this.dataForForm.selectedDate)}T${this.dataForForm.streamStartTime}:00.000Z`
    },
    setStreamEndTime () {
      if (this.dataForForm.streamEndTime) this.dataForForm.sessionForm.streamEndTime = `${this.convertDateToCorrectFormat(this.dataForForm.selectedDate)}T${this.dataForForm.streamEndTime}:00.000Z`
    },
    resetTime (field) {
      this.dataForForm[field] = null
    },
    substring (str, from, end) {
      if (str) return str.substring(from, end)
      else return ''
    },
    isSessionChanged (oldSession, newSession) {
      this.isShowWarningModal = !equals(oldSession, newSession)
    },
    compareSessions (payload) {
      const isCreateSessionForm = this.editedIndex === -1
      if(isCreateSessionForm) return
      const newSessionsListState = {
        location: pathOr(null, ['locationId'], payload),
        sessionType: pathOr(null, ['metadata', 'sessionType'], payload),
        time: (payload.endTime || '').substring(0, 10)
      }
      const oldSessionsListState = clone(this.sessionsListState[payload.id])
      if (oldSessionsListState) {
        oldSessionsListState.time = (oldSessionsListState.time || '').substring(0, 10)
      }
      this.isSessionChanged(oldSessionsListState, newSessionsListState)
    },
    async displayAgendaSettingsDone (id) {
      try {
        if (id) {
          this.deleteSession(id, false)
        }
        await this.getSessions()
      } catch (e) {
        console.error(e)
      } finally {
        this.isShowWarningModal = false
        this.close()
      }
    },
    async saveSession () {
      this.$v.dataForForm.$touch()
      if (this.$v.dataForForm.$invalid) {
        return false
      } else {
        this.setStartTime()
        this.setEndTime()
        this.setStreamEndTime()
        this.setStreamStartTime()
        let payload = clone(this.dataForForm.sessionForm)
        this.compareSessions(payload)
        const charactersLimit = path(['sessionConfiguration', 'askQuestion', 'charactersLimit'] , payload)
        payload.sessionConfiguration.askQuestion.charactersLimit = this.isLimitedCharacters ? charactersLimit : 0
        if (this.isColorBoxChecked) {
          payload.metadata.featuredOptions.backgroundColor = payload.metadata.featuredOptions.backgroundColor.hex
        } else {
          payload.metadata.featuredOptions.backgroundColor = ''
        }
        if (this.isHoverColorBoxChecked) {
          payload.metadata.featuredOptions.hoverBackgroundColor = payload.metadata.featuredOptions.hoverBackgroundColor.hex
        } else {
          payload.metadata.featuredOptions.hoverBackgroundColor = ''
        }
        if (payload.sessionConfiguration.titleColor) {
          payload.sessionConfiguration.titleColor = payload.sessionConfiguration.titleColor.hex
        }
        if (payload.sessionConfiguration.eventColor) {
          payload.sessionConfiguration.eventColor = payload.sessionConfiguration.eventColor.hex
        }
        if(isNil(payload.metadata.moderatorId)) {
          delete payload.metadata.moderatorId
        }
        payload.streamVideoType = this.dataForForm.sessionForm.streamVideoType
        try {
          if (this.editedIndex > -1) {
            await this.editSession(payload)
          } else {
            await this.createSession(payload)
          }
          if (!this.isShowWarningModal){
            await this.displayAgendaSettingsDone()
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    editItem (item) {
      this.editedIndex = this.sessionsList.indexOf(item)
      if (item.location) {
        this.dataForForm.selectedLocation = item.location
      } else {
        this.isMultiLocation = true
      }
      this.dataForForm.selectedDate = this.substring(item.startTime, 0, 10)
      this.dataForForm.startTime = this.substring(item.startTime, 11, 16)
      this.dataForForm.endTime = this.substring(item.endTime, 11, 16)
      this.dataForForm.streamStartTime = this.substring(item.streamStartTime, 11, 16)
      this.dataForForm.streamEndTime = this.substring(item.streamEndTime, 11, 16)
      this.dataForForm.sessionForm = clone(item)
      this.dataForForm.sessionForm.metadata.featuredOptions.backgroundColor = { hex: this.dataForForm.sessionForm.metadata.featuredOptions.backgroundColor }
      this.dataForForm.sessionForm.metadata.featuredOptions.hoverBackgroundColor = { hex: this.dataForForm.sessionForm.metadata.featuredOptions.hoverBackgroundColor }

      // clean up session from speakers that does not exist
      const speakerArePresentedInPublishedSpeakers = item => {
        const matchedSpeaker = this.getPublishedSpeakers.find(propEq('id', item))
        return not(isNil(matchedSpeaker))
      }
      const getIdsOfExistingSpeakers = compose(
        filter(speakerArePresentedInPublishedSpeakers),
        map(prop('id'))
      )
      this.$set(
        this.dataForForm.sessionForm,
        'speakersIds',
        getIdsOfExistingSpeakers(this.dataForForm.sessionForm.speakers)
      )

      delete this.dataForForm.sessionForm.location
      delete this.dataForForm.sessionForm.speakers

      this.isSessionConfiguration = true
      this.dataForForm.sessionForm.sessionConfiguration.timeFontWeight = this.dataForForm.sessionForm.sessionConfiguration.timeFontWeight.toString()
      this.dataForForm.sessionForm.sessionConfiguration.titleFontWeight = this.dataForForm.sessionForm.sessionConfiguration.titleFontWeight.toString()
      this.dataForForm.sessionForm.sessionConfiguration.titleColor = { hex: this.dataForForm.sessionForm.sessionConfiguration.titleColor }
      this.dataForForm.sessionForm.sessionConfiguration.eventColor = { hex: this.dataForForm.sessionForm.sessionConfiguration.eventColor }
      if (this.dataForForm.sessionForm.streamVideoType) this.dataForForm.sessionForm.streamVideoType = this.dataForForm.sessionForm.streamVideoType.toString()
      if (this.dataForForm.sessionForm.sessionConfiguration.askQuestion.charactersLimit > 0) {
        this.isLimitedCharacters = true
      }

      console.log('editItem() -> this.dataForForm', this.dataForForm)
      this.modalWindow = true
    },
    async deleteSession (id, isUpdateSessions = true) {
      try {
        await this.removeSession(id)
        if(isUpdateSessions) {
          this.getSessions()
        }
      } catch (e) {
        console.error(e)
      }
    },
    toggleModal (varModal) {
      this[varModal] = !this[varModal]
    },
    setImage (item) {
      this.dataForForm.sessionForm.metadata.featuredOptions.image = item.imagesUrls.originalImageUrl
      this.toggleModal('modalGallery')
    },
    setLogoImage (url) {
      this.dataForForm.sessionForm.metadata.featuredOptions.logo = url.imagesUrls.originalImageUrl
      this.toggleModal('modalLogoGallery')
    },
    setPlaceholderImage (url) {
      this.dataForForm.sessionForm.placeholderImage = url.imagesUrls.originalImageUrl
      this.toggleModal('modalPlaceholderImageGallery')
    },
    resetImage () {
      this.dataForForm.sessionForm.metadata.featuredOptions.image = ''
    },
    resetLogoImage () {
      this.dataForForm.sessionForm.metadata.featuredOptions.logo = ''
    },
    onColorChange (color) {
      this.dataForForm.sessionForm.metadata.featuredOptions.backgroundColor.hex = color.hex
    },
    onHoverColorChange (color) {
      this.dataForForm.sessionForm.metadata.featuredOptions.hoverBackgroundColor.hex = color.hex
    },
    onTitleColorChange (color) {
      this.dataForForm.sessionForm.sessionConfiguration.titleColor.hex = color.hex
    },
    onEventColorChange (color) {
      this.dataForForm.sessionForm.sessionConfiguration.eventColor.hex = color.hex
    },
    reset () {
      this.filterTitle = ''
      this.filterDescription = ''
      this.locationForFilter = ''
      this.typeForFilter = ''
      this.pagination.sortBy = null
      this.pagination.descending = false
      this.getSessions()
    },
    resetForm () {
      this.$v.dataForForm.$reset()
      this.isMultiLocation = false
      this.dataForForm = clone(this.defaultDataForForm)
      this.editedIndex = -1
      this.isColorBoxChecked = false
      this.isHoverColorBoxChecked = false
    },
    close () {
      this.toggleModal('modalWindow')
    },
    makeDateArr () {
      const range = this.$moment.range(this.minDate, this.maxDate)
      const days = Array.from(range.by('day'));
      let finalDateArr = []
      let dateStringsSelectFormat = days.map(m => m.format('DD MMMM YYYY'))
      finalDateArr = dateStringsSelectFormat.map((item) => {
        return {
          value: this.$moment(item).format('YYYY-MM-DD')
        }
      })
      for (const i in dateStringsSelectFormat) {
        finalDateArr[i].text = dateStringsSelectFormat[i]
      }
      return finalDateArr
    },
    convertDateToCorrectFormat (dateString) {
      return this.$moment(dateString).format('YYYY-MM-DD')
    },
    getSessions: debounce(async function () {
      this.loading = true
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.totalLocationsItems : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: {
          filterTitle: this.filterTitle,
          filterType: this.typeForFilter,
          filterDescription: this.filterDescription
        },
        sortByLocation: this.locationForFilter,
        sort,
        name
      }
      await this.getSessionsList(getParams)
      this.loading = false
    }, timeSettings.delayTime),
    isPaginationChanged (val, oldVal) {
      return val.rowsPerPage !== oldVal.rowsPerPage ||
        val.sortBy !== oldVal.sortBy ||
        val.descending !== oldVal.descending ||
        val.page !== oldVal.page
    }
  },
  async created () {
    this.publishedSpeakers = [...this.getPublishedSpeakers]
    const defaultForm = {
      sessionForm: {
        locationId: null,
        placeholderImage: '',
        shortDescription: '',
        fullDescription: '',
        title: '',
        startTime: '',
        endTime: '',
        streamStartTime: '',
        streamEndTime: '',
        speakersIds: [],
        metadata: {
          featuredOptions: {
            image: '',
            logo: '',
            title: '',
            backgroundColor: {hex: ''},
            hoverBackgroundColor: {hex:''}
          },
          sessionType: 'Regular',
          translator: false
        },
        sessionConfiguration: {
          askQuestion: {
            text: '',
            charactersLimit: 0,
            inputPlaceholder: '',
            title: ''
          },
          emailAddress: '',
          timeFontWeight: '300',
          titleColor: {hex: '#3D85C6'},
          eventColor: {hex: '#3D85C6'},
          titleFontWeight: '600'
        }
      },
      selectedDate: '',
      onDemand: false,
      startTime: null,
      endTime: null,
      selectedLocation: {
        name: ''
      }
    }
    this.dataForForm = clone(defaultForm)
    this.defaultDataForForm = clone(defaultForm)
    this.getSessions()
    this.getLocationsList({itemsOnPage: 100})
    this.fetchSpeakersList()
    if (!this.getSettings) {
      this.fetchGeneralSettings()
    }
  }
}
</script>

<style lang="scss" scoped>
.i-sessions {
  &__content {
    padding: 15px;
  }
}

/deep/ .vc-chrome {
  position: absolute;
  z-index: 20;
}

.height-16 {
  height: 20px;
}

.arrow {
  margin: 0 -10px;
}

.arrow i {
  font-size: 16px;
}

.error-border {
  border: 2px solid red;
}

.draggable-icon {
  margin-right: 10px;
}

.before-drag-drop {
  opacity: 0.35;
  background: lightgray;
}

.drag-container {
  display: flex;
  flex-wrap: wrap;
}

.color-checkbox-block {
  /deep/ .input-group__details {
    display: none;
  }

  /deep/ .controls {
    margin: 0;
  }

  .color-checkbox {
    margin: 10px 0;
  }
}

/deep/ .card__title {
  padding-bottom: 2px;
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Agenda/Sessions/index.vue